// import React from 'react'; // Removed unused React import
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog" // Assuming dialog context for footer
import { Network, Token } from "@/config/tokens" // Changed Tokens to Token (enum)

interface SendPreviewPageProps {
  recipientAddress?: string; // The final address string
  recipientWalletName?: string; // Optional: if a known wallet/contact name exists
  amount: string;
  token: Token; // Use the Token enum
  network: Network;
  onConfirm: () => void;
  onBack: () => void;
  isSending?: boolean; // To disable button during processing, passed from SendFlow's 'process' state indirectly
}

export default function SendPreviewPage({
  recipientAddress,
  recipientWalletName,
  amount,
  token, // This will be Token.USDC, Token.USDT etc.
  network,
  onConfirm,
  onBack,
  isSending,
}: SendPreviewPageProps) {
  return (
    <div className="flex flex-col gap-6 py-4">
      <h3 className="text-lg font-semibold text-center">Confirm Transaction</h3>

      <div className="space-y-3 p-4 border rounded-md bg-gray-50/50">
        <div>
          <p className="text-sm text-gray-500">You are sending</p>
          <p className="text-xl font-bold text-gray-800">
            {amount} {token} {/* Display token enum value directly */}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">To</p>
          {recipientWalletName && (
            <p className="text-md font-medium text-gray-700">
              {recipientWalletName}
            </p>
          )}
          <p className="text-md font-medium text-gray-700 break-all">
            {recipientAddress}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-500">Network</p>
          <p className="text-md font-medium text-gray-700">{network}</p>
        </div>
      </div>

      {/* Optional: Add fee display here if available */}
      {/* <div className="text-sm text-gray-500 text-center">Network fee: ...</div> */}

      <DialogFooter className="mt-2">
        <Button variant="outline" onClick={onBack} disabled={isSending}>
          Back
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isSending}
          data-testid="send-confirm-button"
        >
          {isSending ? "Sending..." : `Send ${amount} ${token} Now`}{" "}
          {/* Display token enum value directly */}
        </Button>
      </DialogFooter>
    </div>
  )
}
